import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import UniversalPopover from './UniversalPopover'
import { getUIWindowSizesWidth } from 'store/entities/ui/selectors'
import { modal } from 'store/entities/modal/actions'

const mapStateToProps = createStructuredSelector({
  windowSizeWidth: getUIWindowSizesWidth,
})

const mapDispatchToProps = {
  showModal: modal.show,
}

export default connect(mapStateToProps, mapDispatchToProps)(UniversalPopover)
